import React, { Component, Fragment } from 'react'
import {
  Row,
  Col,
  Collapse,
  Card,
  Icon,
  Breadcrumb,
  Divider,
  Popover,
} from 'antd'
import { Link } from 'react-router-dom'
import LangContext, { i18n } from 'modules/shared/context/langContext'

class Index extends Component {
  render() {
    const { checkMenuVisibility, web_endpoint, permissions } = this.props
    return (
      <>
        <div className="divider__web__content">
          <Divider />
        </div>
        {/* วัตถุดิบ */}
        {checkMenuVisibility(
          'isupply',
          web_endpoint,
          'masterDataMatrial',
          permissions,
        ) ? (
          <></>
        ) : (
          <Col span={4}>
            <Link to="/material">
              <Card className="card__web__content">
                <Row>
                  <Col span={19}>
                    <p className="report__alern__alarm__text__card__web__content">
                      <LangContext.Consumer>
                        {i18n => i18n.m.masterDataMatrial}
                      </LangContext.Consumer>
                    </p>
                  </Col>
                  <Col span={5} align="center">
                    <Popover
                      placement="bottom"
                      content={
                        <div className="popover__web__content">
                          ใช้สำหรับจัดการข้อมูลวัตถุดิบ
                        </div>
                      }
                    >
                      <Icon
                        type="info-circle"
                        style={{
                          fontSize: 'larger',
                          paddingTop: 17,
                        }}
                        className="icon__web__content"
                      />
                    </Popover>
                  </Col>
                </Row>
                {/* <p className="text__card__web__content">
                  <LangContext.Consumer>
                    {i18n => i18n.m.masterDataMatrial}
                  </LangContext.Consumer>
                </p> */}
              </Card>
            </Link>
          </Col>
        )}
        {/* วัตถุดิบ เทียบ */}
        {checkMenuVisibility(
          'isupply',
          web_endpoint,
          'comparativeRawMaterials',
          permissions,
        ) ? (
          <></>
        ) : (
          <Col span={4}>
            <Link to="/sub-material">
              <Card className="card__web__content">
                <Row>
                  <Col span={19}>
                    <p className="report__alern__alarm__text__card__web__content">
                      <LangContext.Consumer>
                        {i18n => i18n.c.comparativeRawMaterials}
                      </LangContext.Consumer>
                    </p>
                  </Col>
                  <Col span={5} align="center">
                    <Popover
                      placement="bottom"
                      content={
                        <div className="popover__web__content">
                          ใช้สำหรับจัดการข้อมูลวัตถุดิบเทียบ
                        </div>
                      }
                    >
                      <Icon
                        type="info-circle"
                        style={{
                          fontSize: 'larger',
                          paddingTop: 17,
                        }}
                        className="icon__web__content"
                      />
                    </Popover>
                  </Col>
                </Row>
                {/* <p className="text__card__web__content">
                  <LangContext.Consumer>
                    {i18n => i18n.c.comparativeRawMaterials}
                  </LangContext.Consumer>
                </p> */}
              </Card>
            </Link>
          </Col>
        )}
        {/* รายการสั่งวัตถุดิบ */}
        {checkMenuVisibility(
          'isupply',
          web_endpoint,
          'requestMaterial',
          permissions,
        ) ? (
          <></>
        ) : (
          <Col span={4}>
            <Link to="/request-material">
              <Card className="card__web__content">
                <p className="text__card__web__content">
                  <LangContext.Consumer>
                    {i18n => i18n.r.requestMaterial}
                  </LangContext.Consumer>
                </p>
              </Card>
            </Link>
          </Col>
        )}
      </>
    )
  }
}

export default Index
